import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "emp-home-page" }
const _hoisted_2 = { class: "page-content" }
const _hoisted_3 = { class: "welcome-section" }
const _hoisted_4 = { class: "welcome-text" }
const _hoisted_5 = { class: "date-info" }
const _hoisted_6 = { class: "today" }
const _hoisted_7 = { class: "quick-menu-section" }
const _hoisted_8 = { class: "quick-menu-grid" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "menu-label" }
const _hoisted_11 = {
  key: 0,
  class: "recent-wage-section"
}
const _hoisted_12 = { class: "section-title" }
const _hoisted_13 = { class: "wage-header" }
const _hoisted_14 = { class: "wage-month" }
const _hoisted_15 = { class: "wage-amount" }
const _hoisted_16 = { class: "amount" }
const _hoisted_17 = { class: "wage-detail" }
const _hoisted_18 = { class: "detail-item" }
const _hoisted_19 = { class: "detail-value" }
const _hoisted_20 = {
  key: 0,
  class: "detail-item"
}
const _hoisted_21 = { class: "detail-value deduct" }
const _hoisted_22 = { class: "view-more" }
const _hoisted_23 = { class: "notice-section" }
const _hoisted_24 = { class: "section-header" }
const _hoisted_25 = { class: "section-title" }
const _hoisted_26 = { class: "notice-list-card" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "notice-title" }
const _hoisted_30 = { class: "notice-date" }
const _hoisted_31 = {
  key: 1,
  class: "empty-notice"
}
const _hoisted_32 = { class: "info-summary-section" }
const _hoisted_33 = { class: "info-card" }
const _hoisted_34 = { class: "info-row" }
const _hoisted_35 = { class: "info-value" }
const _hoisted_36 = { class: "info-row" }
const _hoisted_37 = { class: "info-value" }
const _hoisted_38 = { class: "info-row" }
const _hoisted_39 = { class: "info-value" }

import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'EmpHome',
  setup(__props) {

const store = useStore();
const router = useRouter();

// 사원 정보
const pwaUser = computed(() => store.getters['pwa/pwaUser']);
const userName = computed(() => pwaUser.value?.display_name || pwaUser.value?.emp_name || '사원');
const userJob = computed(() => pwaUser.value?.emp_job || '-');
const sisulName = computed(() => pwaUser.value?.sisul_name || pwaUser.value?.m_sisul_name || '-');
const empInDate = computed(() => pwaUser.value?.emp_in_date || null);
const sisulCode = computed(() => pwaUser.value?.m_sisul_code || '');

// 최근 급여 정보
const recentWage = ref<any>(null);

// 공지사항
const latestNotice = ref<{ nc_idx: number; nc_title: string } | null>(null);
const noticeList = ref<any[]>([]);

// 공지사항 로드
const loadNotices = async () => {
  try {
    const response = await axios.get('/api/notice/list', {
      params: { page: 1, limit: 5 },
      withCredentials: true
    });
    
    if (response.data.success && response.data.notices.length > 0) {
      latestNotice.value = response.data.notices[0];
      noticeList.value = response.data.notices;
    }
  } catch (error) {
    console.error('공지사항 로드 오류:', error);
  }
};

// 공지사항 페이지로 이동
const goToNotice = () => {
  router.push('/emp/notice');
};

// 공지사항 상세로 이동
const goToNoticeDetail = (ncIdx: number) => {
  router.push(`/emp/notice/${ncIdx}`);
};

// 카테고리 텍스트
const getCategoryText = (category: string) => {
  const map: { [key: string]: string } = {
    'NOTICE': '공지',
    'UPDATE': '업뎃',
    'EVENT': '행사',
    'URGENT': '긴급'
  };
  return map[category] || '공지';
};

// 공지 날짜 포맷
const formatNoticeDate = (date: string) => {
  if (!date) return '';
  const d = new Date(date);
  return `${d.getMonth() + 1}.${d.getDate()}`;
};

// 오늘 날짜
const todayText = computed(() => {
  const today = new Date();
  const options: Intl.DateTimeFormatOptions = { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric', 
    weekday: 'long' 
  };
  return today.toLocaleDateString('ko-KR', options);
});

// 빠른 메뉴
const quickMenus = [
  {
    path: '/emp/payslip',
    label: '급여명세',
    icon: 'mdi-file-document-outline',
    bgColor: '#dcfce7',
    iconColor: '#059669'
  },
  {
    path: '/emp/schedule',
    label: '일정 확인',
    icon: 'mdi-calendar-check',
    bgColor: '#dbeafe',
    iconColor: '#2563eb'
  },
  {
    path: '/emp/myinfo',
    label: '내 정보',
    icon: 'mdi-account-circle',
    bgColor: '#fef3c7',
    iconColor: '#d97706'
  },
  {
    path: '/emp/settings',
    label: '설정',
    icon: 'mdi-cog',
    bgColor: '#f3e8ff',
    iconColor: '#7c3aed'
  }
];

const navigateTo = (path: string) => {
  router.push(path);
};

// 날짜 포맷
const formatDate = (date: string | null | undefined): string => {
  if (!date) return '-';
  try {
    const d = new Date(date);
    return d.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch {
    return date;
  }
};

// 금액 포맷
const formatCurrency = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined) return '0';
  const numValue = typeof value === 'string' ? parseInt(value, 10) : value;
  if (isNaN(numValue)) return '0';
  return numValue.toLocaleString('ko-KR');
};

// 최근 급여 정보 조회
const fetchRecentWage = async () => {
  const empIdxVal = pwaUser.value?.emp_idx;
  if (!empIdxVal || !sisulCode.value) return;

  try {
    const year = new Date().getFullYear();
    const response = await axios.get(
      `/api/emp/payslip-history/${empIdxVal}/${sisulCode.value}/${year}`,
      { withCredentials: true }
    );

    if (response.data.success && response.data.data && response.data.data.length > 0) {
      const latest = response.data.data[0];
      recentWage.value = {
        ...latest,
        month: parseInt(latest.ewi_ym.substring(4, 6), 10),
        type: response.data.type // 'sabok' or 'yobo'
      };
    }
  } catch (error) {
    console.error('최근 급여 정보 조회 오류:', error);
  }
};

onMounted(() => {
  fetchRecentWage();
  loadNotices();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "app-header" }, [
      _createElementVNode("div", { class: "header-title" }, "홈")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, "안녕하세요, " + _toDisplayString(userName.value) + "님!", 1),
          _cache[1] || (_cache[1] = _createElementVNode("p", null, "오늘도 좋은 하루 되세요 ✨", -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(todayText.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "section-title" }, "빠른 메뉴", -1)),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(quickMenus, (menu) => {
            return _createElementVNode("div", {
              key: menu.path,
              class: "quick-menu-item",
              onClick: ($event: any) => (navigateTo(menu.path))
            }, [
              _createElementVNode("div", {
                class: "menu-icon",
                style: _normalizeStyle({ backgroundColor: menu.bgColor })
              }, [
                _createVNode(_component_v_icon, {
                  color: menu.iconColor,
                  size: "28"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(menu.icon), 1)
                  ]),
                  _: 2
                }, 1032, ["color"])
              ], 4),
              _createElementVNode("span", _hoisted_10, _toDisplayString(menu.label), 1)
            ], 8, _hoisted_9)
          }), 64))
        ])
      ]),
      (recentWage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("h3", _hoisted_12, [
              _createVNode(_component_v_icon, {
                size: "20",
                color: "#059669"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-cash-check", -1)
                ]))]),
                _: 1
              }),
              _cache[4] || (_cache[4] = _createTextVNode(" 최근 급여 ", -1))
            ]),
            _createElementVNode("div", {
              class: "wage-card",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateTo('/emp/payslip')))
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(recentWage.value.month) + "월 급여", 1),
                _createElementVNode("span", {
                  class: _normalizeClass(["wage-status", { 'confirmed': recentWage.value.is_closed === 'y' }])
                }, _toDisplayString(recentWage.value.is_closed === 'y' ? '확정' : '진행중'), 3)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "label" }, "실수령액", -1)),
                _createElementVNode("span", _hoisted_16, [
                  _createTextVNode(_toDisplayString(formatCurrency(recentWage.value.ewi_net_pay)), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "unit" }, "원", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "detail-label" }, "총 지급액", -1)),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(formatCurrency(recentWage.value.ewi_total_pay)) + "원", 1)
                ]),
                (parseInt(recentWage.value.ewi_emp_total_deduction || 0) > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "detail-label" }, "총 공제액", -1)),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(formatCurrency(recentWage.value.ewi_emp_total_deduction)) + "원", 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[10] || (_cache[10] = _createElementVNode("span", null, "상세보기", -1)),
                _createVNode(_component_v_icon, {
                  size: "16",
                  color: "#059669"
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("mdi-chevron-right", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("h3", _hoisted_25, [
            _createVNode(_component_v_icon, {
              size: "20",
              color: "#059669"
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("mdi-bullhorn", -1)
              ]))]),
              _: 1
            }),
            _cache[12] || (_cache[12] = _createTextVNode(" 공지사항 ", -1))
          ]),
          _createElementVNode("span", {
            class: "more-link",
            onClick: goToNotice
          }, "더보기")
        ]),
        _createElementVNode("div", _hoisted_26, [
          (noticeList.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noticeList.value, (notice) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: notice.nc_idx,
                    class: "notice-list-item",
                    onClick: ($event: any) => (goToNoticeDetail(notice.nc_idx))
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(['mini-badge', `badge-${notice.nc_category?.toLowerCase()}`])
                    }, _toDisplayString(getCategoryText(notice.nc_category)), 3),
                    _createElementVNode("span", _hoisted_29, _toDisplayString(notice.nc_title), 1),
                    _createElementVNode("span", _hoisted_30, _toDisplayString(formatNoticeDate(notice.nc_wdate)), 1)
                  ], 8, _hoisted_28))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createVNode(_component_v_icon, {
                  size: "24",
                  color: "#ccc"
                }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode("mdi-bulletin-board", -1)
                  ]))]),
                  _: 1
                }),
                _cache[14] || (_cache[14] = _createElementVNode("span", null, "공지사항이 없습니다", -1))
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "section-title" }, "내 정보", -1)),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "info-label" }, "소속", -1)),
            _createElementVNode("span", _hoisted_35, _toDisplayString(sisulName.value), 1)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "info-label" }, "직종", -1)),
            _createElementVNode("span", _hoisted_37, _toDisplayString(userJob.value), 1)
          ]),
          _createElementVNode("div", _hoisted_38, [
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "info-label" }, "입사일", -1)),
            _createElementVNode("span", _hoisted_39, _toDisplayString(formatDate(empInDate.value)), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})